var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.site_settings.site_key)?_c('base-loading'):_c('div',{staticClass:"form-group"},[_c('vue-recaptcha',{attrs:{"sitekey":_vm.site_settings.site_key,"loadRecaptchaScript":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }